import React, { Component } from 'react';
import Layout from './layout.js';
import { connect } from 'react-redux';

class CollaboraorWorkList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Layout
        {...this.props}
      />
    );
  }
}


const mapStateToProps = ({}) => {
  return {};
};
export default connect(mapStateToProps)(CollaboraorWorkList);
